/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 *
 * @author Vladislav Oshkanov
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.0.0
 */

import { FC, ReactNode } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectLoaderIsLoading, makeSelectLoaderText } from '../loaderSelectors';
import {
    LoaderContainerStyled,
    LoaderFrameBackdropStyled,
    LoaderFrameStyled,
    LoaderImageStyled,
    LoaderTextStyled,
} from './styled/LoaderStyled';

/**
 * @description props for loader component
 * @interface ILoaderProps
 *
 * @param {React.ReactNode[]} children - children to render with loader
 * @param {boolean} showLoader - show loader or not
 * @param {string} messages - text under the loader
 */
export interface ILoaderProps {
    children?: ReactNode;
    message?: string;
}

export interface IConnectedProps {
    showLoader: boolean;
    textLoader?: string;
    backdropOpacity?: number;
}

type TLoaderProps = ILoaderProps & IConnectedProps;

export const Loader: FC<TLoaderProps> = (props) => (
    <LoaderContainerStyled aria-busy={props.showLoader} role="progressbar">
        {props.showLoader && (
            <LoaderFrameBackdropStyled opacity={props.backdropOpacity}>
                <LoaderFrameStyled>
                    <LoaderImageStyled>
                        <span />
                        <span />
                        <span />
                        <i />
                    </LoaderImageStyled>
                    {props.textLoader && <LoaderTextStyled>{props.textLoader}</LoaderTextStyled>}
                </LoaderFrameStyled>
            </LoaderFrameBackdropStyled>
        )}
        {props.children}
    </LoaderContainerStyled>
);

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    showLoader: makeSelectLoaderIsLoading(),
    textLoader: makeSelectLoaderText(),
});

export default connect(mapStateToProps)(Loader);
